import Cars from '../services/Cars';
import disablePageScroll from '../helpers/disablePageScroll';
import enablePageScroll from '../helpers/enablePageScroll';
import htmlToDom from '../helpers/htmlToDom';
import Swiper from "swiper";
import Services from "../services/Services";
import StatesSaver from "./statesSaver";

export default (registrationModal) =>
{
	const swiper = new Swiper('.swiper.modal-calc__top-list', {
		loop: true,
		spaceBetween: 20,
		slidesPerView: 4,
		breakpoints: {767: {slidesPerView: 5}}
	});
	const calcParameters =
	{
		mark: null,
		markImg: null,
		model: null,
		modelImg: null,
		modification: null,
		engineCode: null,
		recommendedGoods:
		{
			oilFilter:
			{
				name: null,
				price: 0,
			},
			oil:
			{
				name: null,
				price: 0,
			},
			airFilter:
			{
				name: null,
				price: 0,
			},
			salonFilter:
			{
				name: null,
				price: 0,
			},
			changeAir:
			{
				name: 'Замена воздушного фильтра',
				price: 0,
			},
			changeSalon:
			{
				name: 'Замена салонного фильтра',
				price: 0,
			},
			changeOil:
			{
				name: 'Замена масляного фильтра',
				price: 0,
			},
		},
		fullPrice: 0,
		fullComment: '',
	};

	if ((new URLSearchParams(window.location.search)).get('mark'))
	{
		calcParameters.mark = (new URLSearchParams(window.location.search)).get('mark');
		document.querySelector('.modal-calc__mark-input').value = calcParameters.mark;
	}
	if ((new URLSearchParams(window.location.search)).get('model'))
	{
		calcParameters.model = (new URLSearchParams(window.location.search)).get('model');
		document.querySelector('.modal-calc__model-input').value = calcParameters.model;
	}

	let state = new StatesSaver();
	state.initState();
	let presetServeces =
	{
		'salon':
		{
			name: 'Замена салонного фильтра',
			set: false
		},
		'air':
		{
			name: 'Замена воздушного фильтра',
			set: false
		},
		'gasoline':
		{
			name: 'Фильтр топливный бензин',
			set: false
		},
		'disel':
		{
			name: 'Фильтр топливный дизель',
			set: false
		},
		'oilAndFilterInEngine':
		{
			name: 'Замена масла и фильтра в двигателе',
			set: false
		}
	};

	let startTouchFl = false;
	const modifications = [];
	const firstPageMarksList = document.querySelector('.modal-calc__bottom-list');
	const baseSlider = document.querySelector('.base-slider');

	 let markCallback = async function(e)
	{
		e.preventDefault();
		calcSecondStep(e, true);
		history.pushState({}, null, e.currentTarget.children[1].href);
		await setCache(calcParameters.mark);
	};

	let allCars = [];
	let createMarksList = function()
	{
		if (document.querySelector('.modal-calc__bottom-name[data-mark]'))
		{
			allCars.forEach((car) =>
			{
				document.querySelector('[data-mark="' + car.mark + '"]')?.addEventListener('click', markCallback);
			});
		}
		else if (allCars.length)
		{
			let letter = allCars[0].mark.charAt(0);
			allCars.forEach((car, idx) =>
			{
				let finalLetter;
				if (car.mark.charAt(0) === letter && idx > 0)
					finalLetter = '';
				else
				{
					finalLetter = car.mark.charAt(0);
					letter = car.mark.charAt(0);
				}
				let image = '/images/' + car.mark.toLowerCase().replace(" / ", " ") + '-small.png';
				if (car.image)
					image = car.image;
				const li = htmlToDom(`
                    <li class="modal-calc__bottom-item modal-calc__bottom-item--first" data-mark="${car.mark}">
                        <span class="modal-calc__bottom-letter">${finalLetter}</span>
                        <a class="modal-calc__bottom-link js-modal-calc-item" href=".?calc=1&mark=${car.mark}">
                            <img class="modal-calc__bottom-img" src="${image}" data-mark="${car.mark}">
                            <span class="modal-calc__bottom-name" data-mark="${car.mark}">${car.mark}</span>
                        </a>
                    </li>
                `);
				li.addEventListener('click', markCallback);
				firstPageMarksList.append(li);
			});
		}
	}

	Cars.fetchAll().then((cars) =>
	{
		allCars.push(...cars);
		console.log(allCars);
		createMarksList();
	});

	window.setSlide = (numb) => {
		document
			.querySelector('.base-slider-active')
			?.classList.remove('base-slider-active');
		const isBig = window.screen.width > 900;

		let baseClass = '.base-slider';
		if (isBig) baseClass = '.base-slider-big';

		const slist = document.querySelectorAll(baseClass);

		if (numb >= slist.length) numb = 0;
		if (numb < 0) numb = slist.length;

		slist.forEach((i, iKey) => {
			if (iKey === numb) i.classList.add('base-slider-active');
		});
	};
	const hideFirstElem = (elem) => {
		const nextFirstEl = elem.nextSibling;
		if (nextFirstEl) {
			nextFirstEl.classList.add('first');
			elem.classList.remove('first');
			elem.classList.remove('visible');
			elem.classList.add('notVisible');
		}
	};
	const swapLastElem = (elem, newLastElem) => {
		newLastElem.classList.remove('notVisible');
		newLastElem.classList.add('visible');
		newLastElem.classList.add('last-active');
		elem.classList.remove('last-active');
		elem.parentNode.appendChild(newLastElem);
	};

	const visibleElem = (elem) => {
		const nextLastElem = elem.nextSibling;
		if (nextLastElem) {
			nextLastElem.classList.remove('notVisible');
			nextLastElem.classList.add('visible');
			nextLastElem.classList.add('last-active');
			elem.classList.remove('last-active');
		} else {
			// if (document.querySelectorAll('.slider.visible').length < 4) {
			const newLastElem = elem.parentNode.firstChild;
			swapLastElem(elem, newLastElem);
			// }
		}
	};

	const nextSlide = () => {
		for (let i = 0; i < 4; i++) {
			const firstElem = document.querySelector('.slider.first');
			hideFirstElem(firstElem);
		}
		for (let i = 0; i < 4; i++) {
			const lastElem = document.querySelector('.slider.last-active');
			visibleElem(lastElem);
		}
	};

	const previousSlide = () => {
		for (let i = 0; i < 4; i++) {
			const firstElem = document.querySelector('.slider.first');
			if (firstElem.previousSibling) {
				const nextFirstEl = firstElem.previousSibling;
				nextFirstEl.classList.add('first');
				nextFirstEl.classList.remove('notVisible');
				nextFirstEl.classList.add('visible');
				firstElem.classList.remove('first');
			} else {
				const newFirstEl = firstElem.parentNode.lastChild;
				newFirstEl.classList.add('first');
				newFirstEl.classList.remove('notVisible');
				newFirstEl.classList.add('visible');
				firstElem.classList.remove('first');
				firstElem.parentNode.insertBefore(newFirstEl, firstElem);
			}
		}
		for (let i = 0; i < 4; i++) {
			const lastElem = document.querySelector('.slider.last-active');
			const nextLastElem = lastElem.previousSibling;
			nextLastElem.classList.add('last-active');
			lastElem.classList.remove('last-active');
			lastElem.classList.remove('visible');
			lastElem.classList.add('notVisible');
		}
	};

	window.addEventListener('resize', () => {
		const isBig = window.screen.width > 900;
		const classes = document.querySelector('.base-slider-active')?.classList;
		if (
			(classes?.contains('base-slider') && isBig) ||
			(classes?.contains('base-slider-big') && !isBig)
		)
		setSlide(0);
	});

	setSlide(0);
	const getEvent = () =>
		event.type.search('touch') !== -1 ? event.touches[0] : event;

	let posInit = 0;
	const swipeAction = (event) => {
		if (
			event?.target?.classList.contains('modal-calc__top-list-wrapper') ||
			event?.target?.classList.contains('modal-calc__top-img')
		) {
			const evt = event.changedTouches[0]?.clientX;
			const posX2 = posInit - evt;
			startTouchFl = false;
			if (posX2 > 0) nextSlide();
			else previousSlide();
		}
	};

	window.swipeAction = swipeAction;

	let actualStep = 0;
	let prevStep = 10;

	baseSlider.addEventListener('touchmove', (e) =>
	{
		actualStep += 1;
		if (prevStep === actualStep)
		{
			prevStep = actualStep + 10;
			swipeAction(e);
		}
	});

	window.touchHandlerFunc = (event) => {
		if (
			event.target.classList.contains('modal-calc__top-list-wrapper') ||
			event.target.classList.contains('modal-calc__top-img')
		) {
			const evt = getEvent(event);
			if (startTouchFl === false) {
				startTouchFl = true;
				posInit = evt.clientX;
			}
			// берем начальную позицию курсора по оси Х
			// posInit = evt.clientX;

			swipeAction(posInit);
		}
	};
	const searchCarInput = document.querySelector('.modal-calc__top-input');
	const listToShow = document.querySelector('.modal-calc__top-list--searching');

	searchCarInput.addEventListener('input', (e) =>
	{
		if (!e.currentTarget.value.trim())
		{
			listToShow.innerHTML = '';
			listToShow.classList.remove('modal-calc__top-list--active');
			return;
		}
		listToShow.innerHTML = '';
		listToShow.classList.remove('modal-calc__top-list--active');
		const valueToCompare = e.currentTarget.value.trim().toLocaleLowerCase();
		let foundedCarArray = [];
		allCars.forEach((i) =>
		{
			if (i.mark.toLocaleLowerCase().includes(valueToCompare)) {
				i.models.forEach((j) => {
					foundedCarArray.push({
						mark: i.mark,
						model: j.model
					});
				})
			}
		});

		allCars.forEach((i) =>
		{
			i.models.forEach((j) =>
			{
				if (j.model.toLocaleLowerCase().includes(valueToCompare))
				{
					j.mark = i.mark;
					foundedCarArray.push({
						mark: i.mark,
						model: j.model
					});
				}
			});
		});

		foundedCarArray.forEach((el) =>
		{
			const li = document.createElement('li');
			const link = document.createElement('a');
			li.classList.add('modal-calc__top-item--filter');
			link.classList.add('modal-calc__top-link--filter', 'js-modal-calc-item--filter');
			link.href = '#!';
			link.dataset.mark = el.mark;
			if (el.model) {
				link.dataset.model = el.model;
			};

			link.textContent = el.model ? `${el.mark + ' ' + el.model}` : `${el.mark}`;

			li.addEventListener('click', (e) =>
			{
				e.preventDefault();
				calcSecondStep(e, false);
				document.querySelector('.modal-calc__model-input').disabled = false;
			});
			li.append(link);
			listToShow.append(li);
		});

		if (foundedCarArray.length)
			listToShow.classList.add('modal-calc__top-list--active');
	});

	let modelSearchBar = document.querySelector('.modal-calc__model-input');
	modelSearchBar.addEventListener('input', (e) =>
	{
		let foundModels = [];
		let modelsList = document.querySelector('.modal-calc__model-select');
		let printAll = !e.currentTarget.value.trim();
		const carMark = document.querySelector('.modal-calc__mark-input').value.trim();
		const barInputValue = e.currentTarget.value.trim().toLocaleLowerCase();
		allCars.forEach((i) =>
		{
			if (i.mark === carMark)
			{
				i.models.forEach((j) =>
				{
					if (printAll || j.model.toLocaleLowerCase().includes(barInputValue))
						foundModels.push(j);
				});
			}
		});

		modelsList.innerHTML = '';
		foundModels.forEach((i) =>
		{
			const li = document.createElement('li');
			const link = document.createElement('a');
			li.classList.add('modal-calc__top-item--filter');
			link.classList.add('modal-calc__top-link--filter', 'js-modal-calc-item--filter');
			link.textContent = `${i.mark + ' ' + i.model}`;
			link.href = '#!';
			link.dataset.mark = i.mark;
			link.dataset.model = i.model;
			li.append(link);
			modelsList.append(li);
		});
	});


	let modificationsSearchBar = document.querySelector('.modal-calc__modification-input');
	modificationsSearchBar.addEventListener('input', (e) =>
	{
		let foundModifications = [];
		let modificationsList = document.querySelector('.modal-calc__modification-select');
		let printAll = !e.currentTarget.value.trim();
		let barInputValue = e.currentTarget.value.trim().toLocaleLowerCase();
		modifications.forEach((i) =>
		{
			if (printAll || i.engine.includes(barInputValue) || i.engineCode.includes(barInputValue) || i.power.includes(barInputValue) || i.years.includes(barInputValue))
				foundModifications.push(i);
		});

		for (let i = modificationsList.childNodes.length - 1; i > 4; i--)
			modificationsList.childNodes[i].remove();

		modificationsList.innerHtml = '';
		foundModifications.forEach((i) =>
		{
			const li = document.createElement('li');
			const volume = document.createElement('div');
			const power = document.createElement('div');
			const year = document.createElement('div');
			li.classList.add('modal-calc__modification-select-item');
			volume.classList.add('modal-calc__modification-select-item-volume');
			power.classList.add('modal-calc__modification-select-item-power');
			year.classList.add('modal-calc__modification-select-item-year');
			volume.textContent = i.engine;
			power.textContent = i.power;
			year.textContent = i.years;
			li.dataset.id = i.id;
			li.dataset.engine = i.engine;
			li.dataset.power = i.power;
			li.dataset.years = i.years;
			li.dataset.engineCode = i.engineCode;
			li.append(volume);
			li.append(power);
			li.append(year);
			modificationsList.append(li);
		});
	});


	const calcBtn = document.querySelectorAll('.js-modal-calculator');
	const modalCalc = document.querySelector('.modal-calc');
	const modalCalcWrapper = document.querySelector('.modal-calc-wrapper');
	const modalCalcFirst = document.querySelector('.modal-calc__first');
	const modalCalcSecond = document.querySelector('.modal-calc__second');
	const modalCalcModificationBlock = document.querySelector('.modal-calc__modification');

	calcBtn.forEach((el) =>
	{
		el.addEventListener('click', async (e) =>
		{
			e.preventDefault();
			modalCalcWrapper.classList.toggle('modal-calc-wrapper-active');
			modalCalc.classList.toggle('modal-calc--active');
			el.classList.toggle('header-bottom__btn_disabled');
			if (document.documentElement.clientWidth < 786)
				disablePageScroll();
			state.checkState('calc');
			history.pushState({}, null, e.target.href);
			await setCache();
		});
	});

	document.body.addEventListener('click', (e) =>
	{
		const isClickedAtModalBackdrop =
			e.target.closest('.modal-calc-wrapper') &&
			!e.target.closest('.modal-calc');

		if (isClickedAtModalBackdrop) {
			modalCalcWrapper.classList.remove('modal-calc-wrapper-active');
			modalCalc.classList.remove('modal-calc--active');
			calcBtn.forEach((el) => {
				el.classList.remove('header-bottom__btn_disabled');
			});
			enablePageScroll();
		}
	});

	const closeBtn = document.querySelector('.modal-calc__top-close');
	closeBtn.addEventListener('click', (e) =>
	{
		e.preventDefault();
		modalCalcWrapper.classList.remove('modal-calc-wrapper-active');
		modalCalc.classList.remove('modal-calc--active');
		calcBtn.forEach((el) => {
			el.classList.remove('header-bottom__btn_disabled');
		});
		enablePageScroll();
		history.pushState({}, null, '.');
	});

	const calcCars = document.querySelectorAll('.js-modal-calc-item');
	const inputMark = document.querySelector('.modal-calc__mark-input');
	const closeMark = document.querySelector('.modal-calc__mark-close');
	const inputMarkImg = document.querySelector('.modal-calc__mark-input-img');
	const inputModel = document.querySelector('.modal-calc__model-input');
	const closeModel = document.querySelector('.modal-calc__model-close');

	const inputModification = document.querySelector('.modal-calc__modification-input');
	const closeModification = document.querySelector('.modal-calc__modification-close');
	const calcBtns = document.querySelector('.modal-calc__bottom-btn-wrapper');
	const calcBtnsMobile = document.querySelector('.modal-calc__bottom-btn-wrapper-mobile');
	const calcPrevBtn = document.querySelector('.modal-calc__bottom-btn-prev');
	const calcNextBtn = document.querySelector('.modal-calc__bottom-btn-next');
	const calcModelSelect = document.querySelector('.modal-calc__model-select');
	const modelImgWrapper = document.querySelector('.modal-calc__model-img-wrapper');

	const calcTableBlock = document.querySelector('.modal-calc__table-wrapper');

	const secondStepTitle = document.querySelector('.modal-calc__second-title');
	const calcMarkHeader = document.querySelector('.modal-calc__mark > h3');
	const calcModelHeader = document.querySelector('.modal-calc__model > h3');
	const calcModificationHeader = document.querySelector('.modal-calc__modification > h3');

	if (inputMark.dataset.mark)
	{
		calcParameters.mark = inputMark.dataset.mark;
		inputMark.value = inputMark.dataset.mark;
	}

	calcCars.forEach((el) =>
	{
		el.addEventListener('click', (e) =>
		{
			e.preventDefault();
			calcSecondStep(e, true);
			history.pushState({}, null, e.target.href);
		});
	});

	function calcSecondStep(e, onClick)
	{
		if (onClick)
		{
			calcParameters.mark = e.currentTarget.dataset.mark;
			if (!calcParameters.mark)
				calcParameters.mark = e.target.dataset.mark;
			calcParameters.model = e.currentTarget.dataset.model;
			if (!calcParameters.model)
				calcParameters.model = e.target.dataset.model;
		}
		else
		{
			calcParameters.mark = e.target.dataset.mark;
			if (!calcParameters.mark)
				calcParameters.mark = e.currentTarget.dataset.mark;
			calcParameters.model = e.target.dataset.model;
			if (!calcParameters.model)
				calcParameters.model = e.currentTarget.dataset.model;
		}

		state.calc.setCarMark(calcParameters.mark);
		state.calc.setStep(2);

		if (calcParameters.model)
		{
			state.calc.setCarModel(calcParameters.model);
			state.calc.setStep(3);
		}

		modalCalcFirst.classList.add('none');
		modalCalcSecond.classList.add('modal-calc__second-active');
		calcNextBtn.classList.add('modal-calc__bottom-btn-next-disabled');
		calcBtns.classList.add('modal-calc__bottom-btn-wrapper-active');
		modelImgWrapper.innerHTML = ``;
		secondStepTitle.textContent = 'Выберите модель';

		let img = allCars.filter((car) => car.mark === calcParameters.mark)[0].image;
		calcParameters.markImg = `/images/${calcParameters.mark.toLowerCase()}-small.png`;
		if (img)
			calcParameters.markImg = img;

		inputMark.value = calcParameters.mark.toUpperCase();
		inputMarkImg.src = calcParameters.markImg;
		inputMarkImg.style.width = '24px';
		inputMarkImg.style.height = '24px';
		closeMark.classList.add('modal-calc__input-close-active');

		const { models } = allCars.filter((car) => car.mark === calcParameters.mark)[0];
		calcModelSelect.innerHTML = '';
		models.forEach((model) =>
		{
			const li = document.createElement('li');
			const link = document.createElement('a');
			li.classList.add('modal-calc__model-select-item');
			link.classList.add(
				'modal-calc__select-link',
				'modal-calc__model-select-link'
			);
			link.textContent = model.model;
			link.href = '.?calc=1&mark=' + calcParameters.mark + '&model=' + model.model;
			link.dataset.model = model.model;
			link.dataset.modelImg = model.imageUrl;
			li.append(link);
			calcModelSelect.append(li);
		});

		if (typeof calcParameters.model !== 'undefined')
		{
			secondStepTitle.textContent = 'Выберите модификацию';
			document.querySelector('.modal-calc__model-input').value = e.target.dataset.model;
			calcModelSelectFn(e, false);
			history.pushState({}, null, e.target.href);
			setCache(calcParameters.mark, calcParameters.model);
		}
	}

	const calcModificationsSelect = document.querySelector('.modal-calc__modification-select');
	const inputModificationFilled = document.querySelector('.modal-calc__modification-input-filled');
	calcModelSelect.addEventListener('click', (e) =>
	{
		e.preventDefault();
		secondStepTitle.textContent = 'Выберите модификацию';
		document.querySelector('.modal-calc__model-input').value = e.target.dataset.model;
		calcModelSelectFn(e, true);
	});
	const modelSearchIcon = document.querySelector('.modal-calc__model-input-img');
	const modelInputBlock = document.querySelector('.modal-calc__input-block-model');
	const modificationSpinner = document.querySelector('[data-calc-mod-spinner]');

	function calcModelSelectFn(e, onClick)
	{
		if (onClick)
		{
			calcParameters.model = e.target.dataset.model;
			calcParameters.modelImg = e.target.dataset.modelImg;
		}
		else
		{
			calcParameters.model = e.target.dataset.model;
			calcParameters.modelImg = allCars
				.find((car) => calcParameters.mark === car.mark)
				.models.find((model) => calcParameters.model === model.model).imageUrl;
		}

		state.calc.setCarModel(calcParameters.model);
		state.calc.setStep(3);

		modificationSpinner.classList.remove('d-none');
		modificationSpinner.parentElement.classList.remove('d-none');

		modifications.splice(0, modifications.length);
		Cars.fetchModifications(calcParameters.mark, calcParameters.model).then((res) =>
		{
			modifications.push(...res);
			createModificationsList();
			modificationSpinner.classList.add('d-none');
			modificationSpinner.parentElement.classList.add('d-none');
			history.pushState({}, null, e.target.href);
			setCache(calcParameters.mark, calcParameters.model);
		});

		inputModificationFilled.innerHTML = ``;
		modelImgWrapper.innerHTML = ``;
		inputModification.classList.remove('none');
		inputModificationFilled.classList.remove('modal-calc__modification-input-filled-active');
		calcModificationsSelect.classList.add('modal-calc__modification-select-active');

		calcModelSelect.classList.add('modal-calc__model-select-hide');
		modelSearchIcon.classList.add('modal-calc__model-input-img-hide');
		modelInputBlock.classList.add('modal-calc__input-block-model-choosen');

		closeModel.classList.add('modal-calc__input-close-active');
		if (calcParameters.modelImg)
		{
			const img = document.createElement('img');
			img.classList.add('modal-calc__model-img');
			img.src = calcParameters.modelImg;
			modelImgWrapper.append(img);
		}
		const prevMod = calcModificationsSelect.querySelectorAll('.modal-calc__modification-select-item-volume');
		prevMod.forEach((mod) => mod.parentElement.remove());
		modalCalcModificationBlock.classList.add('modal-calc__modification-active');
	}

	function createModificationsList()
	{
		modifications.forEach((modification) =>
		{
			const li = document.createElement('li');
			const volume = document.createElement('div');
			const power = document.createElement('div');
			const year = document.createElement('div');
			li.classList.add('modal-calc__modification-select-item');
			volume.classList.add('modal-calc__modification-select-item-volume');
			power.classList.add('modal-calc__modification-select-item-power');
			year.classList.add('modal-calc__modification-select-item-year');
			volume.textContent = modification.engine;
			power.textContent = modification.power;
			year.textContent = modification.years;
			li.dataset.id = modification.id;
			li.dataset.engine = modification.engine;
			li.dataset.power = modification.power;
			li.dataset.years = modification.years;
			li.dataset.engineCode = modification.engineCode;
			li.append(volume);
			li.append(power);
			li.append(year);
			calcModificationsSelect.append(li);
		});
	}

	const modificationSearchIcon = document.querySelector('.modal-calc__modification-input-img');
	const modificationInputBlock = document.querySelector('.modal-calc__input-block-modification');

	calcModificationsSelect.addEventListener('click', (e) =>
	{
		e.preventDefault();

		calcModificationsSelect.classList.add('modal-calc__modification-select-hide');
		modificationSearchIcon.classList.add('modal-calc__modification-input-img-hide');
		modificationInputBlock.classList.add('modal-calc__input-block-modification-choosen');

		inputModificationFilled.innerHTML = ``;
		const volume = document.createElement('div');
		const power = document.createElement('div');
		const year = document.createElement('div');
		volume.classList.add('modal-calc__modification-select-item-volume');
		power.classList.add('modal-calc__modification-select-item-power');
		year.classList.add('modal-calc__modification-select-item-year');
		if (e.target.tagName === 'DIV')
		{
			calcParameters.modification = e.target.parentElement.dataset.id;
			calcParameters.engineCode = e.target.parentElement.dataset.engineCode;
			volume.textContent = e.target.parentElement.dataset.engine;
			power.textContent = e.target.parentElement.dataset.power;
			year.textContent = e.target.parentElement.dataset.years;
		}
		else
		{
			calcParameters.modification = e.target.dataset.id;
			calcParameters.engineCode = e.target.dataset.engineCode;
			volume.textContent = e.target.dataset.engine;
			power.textContent = e.target.dataset.power;
			year.textContent = e.target.dataset.years;
		}

		state.calc.setCarModification(calcParameters.modification);
		state.calc.setCarModificationName(volume.textContent + ' ' + power.textContent + ' ' + year.textContent);
		state.calc.setStep(4);

		inputModificationFilled.append(volume);
		inputModificationFilled.append(power);
		inputModificationFilled.append(year);
		inputModification.classList.add('none');
		inputModificationFilled.classList.add('modal-calc__modification-input-filled-active');

		closeModification.classList.add('modal-calc__input-close-active');
		calcNextBtn.classList.remove('modal-calc__bottom-btn-next-disabled');
		if (document.documentElement.clientWidth < 1650)
		{
			calcNextBtn.click();
		}
	});

	closeMark.addEventListener('click', (e) =>
	{
		e.preventDefault();

		calcSecondToFirst(e);

		calcModelSelect.classList.remove('modal-calc__model-select-hide');
		closeModel.classList.remove('modal-calc__input-close-active');
		modelSearchIcon.classList.remove('modal-calc__model-input-img-hide');
		modelInputBlock.classList.remove('modal-calc__input-block-model-choosen');
		calcModificationsSelect.classList.remove('modal-calc__modification-select-hide');
		closeModification.classList.remove('modal-calc__input-close-active');
		modificationSearchIcon.classList.remove('modal-calc__modification-input-img-hide');
		modificationInputBlock.classList.remove('modal-calc__input-block-modification-choosen');
		calcBtnsMobile.classList.remove('modal-calc__bottom-btn-wrapper-mobile-active');

		tableBodyWrapper.innerHTML = ``;

		calcTableBlock.classList.remove('modal-calc__table-wrapper-active');
		calcModelSelect.classList.remove('none');
		calcModificationsSelect.classList.remove('none');
		calcMarkHeader.textContent = 'Выберите марку автомобиля';
		calcModelHeader.textContent = 'Выберите модель';
		calcModificationHeader.textContent = 'Выберите модификацию';
		calcNextBtn.textContent = 'Далее';

		history.pushState({}, null, '.?calc=1');
		setCache();
	});

	closeModel.addEventListener('click', (e) => {
		e.preventDefault();
		calcThirdToSecond(e);
		history.pushState({}, null, '.?calc=1&mark=' + calcParameters.mark);
		setCache(calcParameters.mark);
	});

	closeModification.addEventListener('click', (e) => {
		e.preventDefault();

		calcModificationsSelect.classList.remove(
			'modal-calc__modification-select-hide'
		);
		modificationSearchIcon.classList.remove(
			'modal-calc__modification-input-img-hide'
		);
		modificationInputBlock.classList.remove(
			'modal-calc__input-block-modification-choosen'
		);
		calcBtnsMobile.classList.remove(
			'modal-calc__bottom-btn-wrapper-mobile-active'
		);
		modificationSpinner.classList.remove('d-none');

		secondStepTitle.textContent = 'Выберите модификацию';

		tableBodyWrapper.innerHTML = ``;

		inputModificationFilled.innerHTML = ``;
		inputModification.classList.remove('none');
		inputModificationFilled.classList.remove(
			'modal-calc__modification-input-filled-active'
		);
		calcTableBlock.classList.remove('modal-calc__table-wrapper-active');
		calcModelSelect.classList.remove('none');
		calcModificationsSelect.classList.remove('none');
		calcMarkHeader.textContent = 'Выберите марку автомобиля';
		calcModelHeader.textContent = 'Выберите модель';
		calcModificationHeader.textContent = 'Выберите модификацию';
		calcNextBtn.textContent = 'Далее';
		closeModification.classList.remove('modal-calc__input-close-active');
		calcNextBtn.classList.add('modal-calc__bottom-btn-next-disabled');

		history.pushState({}, null, '.?calc=1&mark=' + calcParameters.mark + '&model=' + calcParameters.model);
		setCache(calcParameters.mark, calcParameters.model);
	});
	const tableSpinner = document.querySelector('[data-calc-table-spinner]');
	calcNextBtn.addEventListener('click', (e) =>
	{
		if (!calcNextBtn.classList.contains('modal-calc__bottom-btn-next-disabled'))
		{
			e.preventDefault();
			if (!calcTableBlock.classList.contains('modal-calc__table-wrapper-active'))
			{
				tableSpinner?.classList.remove('d-none');
				calcThirdStep(e);
				history.pushState({}, null, '.?calc=1&mark=' + calcParameters.mark + '&model=' + calcParameters.model + '&modification=' + calcParameters.modification);
			}
			else
			{
				openRegistration();
			}
		}
	});

	const sumAll = document.querySelector('.modal-calc__sum-num');

	function completeThirdStepFromCache()
	{
		let url = (new URLSearchParams(window.location.search));
		calcParameters.mark = url.get('mark');
		calcParameters.model = url.get('model');
		calcParameters.modification = url.get('modification');
		document.querySelector('.modal-calc__mark-input').value = url.get('mark');
		document.querySelector('.modal-calc__model-input').value = url.get('model');
		const oilFilterList = [];
		const recommendedOilList = [];
		const airFilterList = [];
		const salonFilterList = [];

		Promise.all([
			fetchOilFilter(),
			fetchRecommendedOil(),
			fetchAirFilter(),
			fetchSalonFilter(),
			fetchChangeFilter(),
		]).then(([oilFilter, recommOil, airFilter, salonFilter, changePrice]) =>
		{
			oilFilterList.push(...oilFilter);
			+recommOil === 0 ? recommendedOilList.push(recommOil) : recommendedOilList.push(...recommOil);
			airFilterList.push(...airFilter);
			salonFilterList.push(...salonFilter);
			createTable(
				oilFilterList,
				recommendedOilList,
				airFilterList,
				salonFilterList,
				changePrice,
				true
			);
		});
	}

	if ((new URLSearchParams(window.location.search)).get('modification'))
		completeThirdStepFromCache();

	function calcThirdStep(e)
	{
		tableSpinner?.classList.remove('d-none');
		document.querySelector('.modal-calc__sum').style.display = 'none';
		const oilFilterList = [];
		const recommendedOilList = [];
		const airFilterList = [];
		const salonFilterList = [];

		Promise.all([
			fetchOilFilter(),
			fetchRecommendedOil(),
			fetchAirFilter(),
			fetchSalonFilter(),
			fetchChangeFilter(),
		]).then(([oilFilter, recommOil, airFilter, salonFilter, changePrice]) =>
		{
			oilFilterList.push(...oilFilter);
			+recommOil === 0 ? recommendedOilList.push(recommOil) : recommendedOilList.push(...recommOil);
			airFilterList.push(...airFilter);
			salonFilterList.push(...salonFilter);
			createTable(
				oilFilterList,
				recommendedOilList,
				airFilterList,
				salonFilterList,
				changePrice
			);
			tableSpinner?.classList.add('d-none');
			document.querySelector('.modal-calc__sum').style.display = 'block';
			setCache(calcParameters.mark, calcParameters.model, calcParameters.modification);
		});

		calcModelSelect.classList.add('none');
		calcModificationsSelect.classList.add('none');
		calcTableBlock.classList.add('modal-calc__table-wrapper-active');
		calcBtnsMobile.classList.add('modal-calc__bottom-btn-wrapper-mobile-active');

		secondStepTitle.textContent = 'Рекомендуемые товары';

		calcMarkHeader.textContent = 'Марка автомобиля';
		calcModelHeader.textContent = 'Модель';
		calcModificationHeader.textContent = 'Модификация';
		calcNextBtn.textContent = 'Записаться';

		sumAll.textContent = '0';

		const reqButton = document.querySelector('.modal-calc__btn-rec');
		reqButton.addEventListener('click', (e) => { openRegistration(); });
	}

	function fetchOilFilter() {
		return Cars.fetchOilFilter(calcParameters.modification);
	}

	function fetchRecommendedOil() {
		return Cars.fetchRecommendedOil(calcParameters.modification);
	}

	function fetchAirFilter() {
		return Cars.fetchAirFilter(calcParameters.modification);
	}

	function fetchSalonFilter() {
		return Cars.fetchSalonFilter(calcParameters.modification);
	}

	function fetchChangeFilter() {
		return Cars.fetchChangePrice();
	}

	const tableBodyWrapper = document.querySelector(
		'.modal-calc__table-body-wrapper'
	);

	function createTable(
		oilFilterList,
		recommendedOilList,
		airFilterList,
		salonFilterList,
		changePrice,
		fromCache = false
	) {
		const isOilFilterHas = oilFilterList.length > 1;
		const isOilHas = recommendedOilList.length > 1;
		const isAirFilterHas = airFilterList.length > 1 && airFilterList[0].length > 0;
		const isSalonFilterHas = salonFilterList.length > 1 && salonFilterList[0].length > 0;
		const oilFilterArr = [];
		const recommendOilArr = [];
		const airFilterArr = [];
		const salonFilterArr = [];

		if (isOilFilterHas)
		{
			presetServeces['oilAndFilterInEngine']['set'] = true;
			for (let i = 0; i < oilFilterList[0].length; i++) {
				oilFilterArr[i] = {
					name: oilFilterList[0][i],
					id: oilFilterList[1][i],
					price: oilFilterList[2][i],
					count: oilFilterList[3][i],
					image: oilFilterList[4][i]
				};
			}
		}
		else
			presetServeces['oilAndFilterInEngine']['set'] = false;

		if (isOilHas)
		{
			presetServeces['oilAndFilterInEngine']['set'] = true;
			for (let i = 0; i < recommendedOilList[0].length; i++)
			{
				recommendOilArr[i] = {
					name: recommendedOilList[0][i],
					id: recommendedOilList[1][i],
					value: recommendedOilList[2][i],
					price: recommendedOilList[3][i],
					image: recommendedOilList[4][i]
				};
			}
		}
		else
			presetServeces['oilAndFilterInEngine']['set'] = false;

		if (isAirFilterHas)
		{
			presetServeces['air']['set'] = true;
			for (let i = 0; i < airFilterList[0].length; i++) {
				airFilterArr[i] =
				{
					name: airFilterList[0][i],
					id: airFilterList[1][i],
					price: airFilterList[2][i],
					count: airFilterList[3][i],
					image: airFilterList[4][i]
				};
			}
		}
		else
			presetServeces['air']['set'] = false;

		if (isSalonFilterHas)
		{
			presetServeces['salon']['set'] = true;
			for (let i = 0; i < salonFilterList[0].length; i++)
			{
				salonFilterArr[i] = {
					name: salonFilterList[0][i],
					id: salonFilterList[1][i],
					price: salonFilterList[2][i],
					count: salonFilterList[3][i],
					image: salonFilterList[4][i]
				};
			}
		}
		else
			presetServeces['salon']['set'] = false;

		if (!fromCache)
		{
			const tableBody = htmlToDom(`
				<table class="modal-calc__table">
					<tbody class="modal-calc__table-body">
						<tr class="modal-calc__table-row modal-calc__table-section">
							<td class="modal-calc__table-item-recomend modal-calc__table-item-main">
								<div class="modal-calc__table-item">
									<div class="modal-calc__table-item modal-calc__table-item-image-wrapper">
										<img src="/images/oilfilter.png" class="modal-calc__table-item-image">
									</div>
									<div class="modal-calc__table-item">
										Масляные фильтры:
									</div>
								</div>
							</td>
						</tr>
						${oilFilterArr.length ? oilFilterArr.map((oilFilter, idx) => tableFilterElement(oilFilter, 'oil', idx)).map((el) => el.firstElementChild.firstElementChild.outerHTML).join('') : ''}
						<tr class="modal-calc__table-row modal-calc__table-section ${oilFilterArr.length > 1 ? '' : 'd-none'}">
							<td colspan="3">
								<div class="modal-calc__table-item modal-calc__table-showmore showmore-oil-filter">
									Показать больше масляных фильтров
								</div>
							</td>
						</tr>
						<tr class="modal-calc__table-row modal-calc__table-section">
							<td class="modal-calc__table-item-recomend modal-calc__table-item-main">
								<div class="modal-calc__table-item">
									<div class="modal-calc__table-item modal-calc__table-item-image-wrapper">
										<img src="/images/recommendedOil.png" class="modal-calc__table-item-image">
									</div>
									<div class="modal-calc__table-item">
										Рекомендуемое масло:
									</div>
								</div>
							</td>
						</tr>
						${recommendOilArr.map((recommendedOil, idx) => tableOilElement(recommendedOil, idx, 'recOil')).map((el) => el.firstElementChild.firstElementChild.outerHTML).join('')}
						<tr class="modal-calc__table-row modal-calc__table-section ${recommendOilArr.length > 1 ? '' : 'd-none'}">
							<td colspan="3">
								<div class="modal-calc__table-item modal-calc__table-showmore showmore-oil">
									Показать больше масел
								</div>
							</td>
						</tr>
						<tr class="modal-calc__table-row modal-calc__table-section">
							<td class="modal-calc__table-item-recomend modal-calc__table-item-main">
								<div class="modal-calc__table-item">
									<div class="modal-calc__table-item modal-calc__table-item-image-wrapper">
										<img src="/images/airfilter.png" class="modal-calc__table-item-image">
									</div>
									<div class="modal-calc__table-item">
										Воздушные фильтры:
									</div>
								</div>
							</td>
						</tr>
						${airFilterArr.length ? airFilterArr.map((airFilter, idx) => tableFilterElement(airFilter, 'air', idx)).map((el) => el.firstElementChild.firstElementChild.outerHTML).join('') : ''}
						<tr class="modal-calc__table-row modal-calc__table-section ${airFilterArr.length > 1 ? '' : 'd-none'}">
							<td colspan="3">
								<div class="modal-calc__table-item modal-calc__table-showmore showmore-air-filter">
									Показать больше воздушных фильтров
								</div>
							</td>
						</tr>
						<tr class="${airFilterArr.length ? 'modal-calc__table-row modal-calc__table-section' : 'd-none'}">
							<td class="modal-calc__table-item-recomend">
								Замена воздушного фильтра
							</td>
							<td class="modal-calc__table-item-volume"></td>
							<td class="modal-calc__table-item-cost">
								<div class="${airFilterArr.length ? 'modal-calc__table-item-cost-wrapper' : 'd-none'} ">
									<div class="modal-calc__table-item"><span class="modal-calc__table-item-cost-span">Цена:&nbsp</span>${Math.round(changePrice[1])}₽</div>
									<div class="modal-calc__table-item modal-calc__table-switch-wrapper">
										<label class="modal-calc__table-switch">
											<input type="checkbox" value="${airFilterArr.length ? changePrice[1] : 0}" class="modal-calc__table-switch-checkbox" data-change-air>
											<div class="modal-calc__table-switch-slider"></div>
										</label>
									</div>
								</div>
							</td>
						</tr>
						<tr class="modal-calc__table-row modal-calc__table-section">
							<td class="modal-calc__table-item-recomend modal-calc__table-item-main">
								<div class="modal-calc__table-item">
									<div class="modal-calc__table-item modal-calc__table-item-image-wrapper">
										<img src="/images/salonfilter.png" class="modal-calc__table-item-image">
									</div>
									<div class="modal-calc__table-item">
										Салонные фильтры:
									</div>
								</div>
							</td>
						</tr>
						${salonFilterArr.length ? salonFilterArr.map((salonFilter, idx) => tableFilterElement(salonFilter, 'salon', idx)).map((el) => el.firstElementChild.firstElementChild.outerHTML).join('') : ''}
						<tr class="modal-calc__table-row modal-calc__table-section ${salonFilterArr.length > 1 ? '' : 'd-none'}">
							<td colspan="3">
								<div class="modal-calc__table-item modal-calc__table-showmore showmore-salon-filter">
									Показать больше салонных фильтров
								</div>
							</td>
						</tr>
						<tr class="${salonFilterArr.length ? 'modal-calc__table-row modal-calc__table-section' : 'd-none'}">
							<td class="modal-calc__table-item-recomend">
								Замена салонного фильтра
							</td>
							<td class="modal-calc__table-item-volume"></td>
							<td class="modal-calc__table-item-cost">
								<div class="${salonFilterArr.length ? 'modal-calc__table-item-cost-wrapper' : 'd-none'} ">
									<div class="modal-calc__table-item"><span class="modal-calc__table-item-cost-span">Цена:&nbsp</span>${Math.round(changePrice[2])}₽</div>
									<div class="modal-calc__table-item modal-calc__table-switch-wrapper">
										<label class="modal-calc__table-switch">
											<input type="checkbox" value="${salonFilterArr.length ? changePrice[2] : 0}" class="modal-calc__table-switch-checkbox" data-change-salon>
											<div class="modal-calc__table-switch-slider"></div>
										</label>
									</div>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			`);

			tableBodyWrapper.append(tableBody);
		}

		const tableOilItem = document.querySelectorAll('.modal-calc__table-oil-hidden');
		const tableFilterOilItem = document.querySelectorAll('.modal-calc__table-filter-oil-hidden');
		const tableFilterAirItem = document.querySelectorAll('.modal-calc__table-filter-air-hidden');
		const tableFilterSalonItem = document.querySelectorAll('.modal-calc__table-filter-salon-hidden');
		const showMoreOil = document.querySelectorAll('.modal-calc__table-showmore');
		showMoreOil.forEach((i) =>
		{
			i.addEventListener('click', (e) =>
			{
				if (e.target.innerText === 'Показать больше масел')
				{
					tableOilItem.forEach((item) => {item.classList.remove('d-none');});
					e.target.textContent = 'Свернуть масла';
				}
				else if (e.target.innerText === 'Свернуть масла')
				{
					tableOilItem.forEach((item) => {item.classList.add('d-none');});
					e.target.textContent = 'Показать больше масел';
				}
				else if (e.target.innerText === 'Показать больше масляных фильтров')
				{
					tableFilterOilItem.forEach((item) => {item.classList.remove('d-none');});
					e.target.textContent = 'Свернуть масляные фильтры';
				}
				else if (e.target.innerText === 'Свернуть масляные фильтры')
				{
					tableFilterOilItem.forEach((item) => {item.classList.add('d-none');});
					e.target.textContent = 'Показать больше масляных фильтров';
				}
				else if (e.target.innerText === 'Показать больше воздушных фильтров')
				{
					tableFilterAirItem.forEach((item) => {item.classList.remove('d-none');});
					e.target.textContent = 'Свернуть воздушные фильтры';
				}
				else if (e.target.innerText === 'Свернуть воздушные фильтры')
				{
					tableFilterAirItem.forEach((item) => {item.classList.add('d-none');});
					e.target.textContent = 'Показать больше воздушных фильтров';
				}
				else if (e.target.innerText === 'Показать больше салонных фильтров')
				{
					tableFilterSalonItem.forEach((item) => {item.classList.remove('d-none');});
					e.target.textContent = 'Свернуть салонные фильтры';
				}
				else if (e.target.innerText === 'Свернуть салонные фильтры')
				{
					tableFilterSalonItem.forEach((item) => {item.classList.add('d-none');});
					e.target.textContent = 'Показать больше салонных фильтров';
				}
			});
		});

		const changeAirFilter = document.querySelector('[data-change-air]');
		const changeSalonFilter = document.querySelector('[data-change-salon]');

		const siteStates = JSON.parse(localStorage.getItem('siteStates'));
    	const changeState = siteStates?.calc?.change;

		if (changeAirFilter)
			changeAirFilter.checked = changeState.air;
    	if (changeSalonFilter)
    		changeSalonFilter.checked = changeState.salon;

		calcParameters.recommendedGoods.changeAir.price = changeAirFilter.checked ? +changeAirFilter.value : 0;
    	calcParameters.recommendedGoods.changeSalon.price = changeSalonFilter.checked ? +changeSalonFilter.value : 0;

		changeAirFilter?.addEventListener('change', (e) => {
        const isChecked = e.target.checked;
        calcParameters.recommendedGoods.changeAir.price = isChecked ? +e.target.value : 0;
        state.calc.setChangeAir(isChecked);
        sumFullPrice();
    });

    changeSalonFilter?.addEventListener('change', (e) => {
        const isChecked = e.target.checked;
        calcParameters.recommendedGoods.changeSalon.price = isChecked ? +e.target.value : 0;
        state.calc.setChangeSalon(isChecked);
        sumFullPrice();
    });

		const oilItem = document.querySelectorAll('.modal-calc__table-radio-input[name=recOil]');
		if (oilItem.length > 0)
		{
			oilItem[0].setAttribute('checked', 'checked');
			calcParameters.recommendedGoods.oil.price = +oilItem[0].value;
			calcParameters.recommendedGoods.oil.name = oilItem[0].dataset.oilName;
			oilItem.forEach((el, idx) =>
			{
				el.addEventListener('click', (e) =>
				{
					calcParameters.recommendedGoods.oil.price = +e.target.value;
					calcParameters.recommendedGoods.oil.name = e.target.dataset.oilName;
					sumFullPrice();
					state.calc.setGoodsOil(calcParameters.recommendedGoods.oil.name);
				});
			});
		}


		const oilFilterItem = document.querySelectorAll('.modal-calc__table-radio-input[name=oil]');
		if (oilFilterItem.length > 0)
		{
			oilFilterItem[0].setAttribute('checked', 'checked');
			calcParameters.recommendedGoods.oilFilter.price = +oilFilterItem[0].value;
			calcParameters.recommendedGoods.oilFilter.name = oilFilterItem[0].dataset.filterName;
			oilFilterItem.forEach((el) =>
			{
				el.addEventListener('click', (e) =>
				{
					if (e.target.checked)
					{
						calcParameters.recommendedGoods.oilFilter.price = +e.target.value;
						calcParameters.recommendedGoods.oilFilter.name = e.target.dataset.filterName;
					}
					else
					{
						calcParameters.recommendedGoods.oilFilter.price = 0;
						calcParameters.recommendedGoods.oilFilter.name = '';
					}
					sumFullPrice();
					state.calc.setGoodsOilFilter(calcParameters.recommendedGoods.oilFilter.name);
				});
			});
		}

		const airFilterItem = document.querySelectorAll('.modal-calc__table-radio-input[name=air]');
		if (airFilterItem.length > 0)
		{
			airFilterItem[0].setAttribute('checked', 'checked');
			calcParameters.recommendedGoods.airFilter.price = +airFilterItem[0].value;
			calcParameters.recommendedGoods.airFilter.name = airFilterItem[0].dataset.filterName;
			airFilterItem.forEach((el) =>
			{
				el.addEventListener('click', (e) =>
				{
					if (e.target.checked)
					{
						calcParameters.recommendedGoods.airFilter.price = +e.target.value;
						calcParameters.recommendedGoods.airFilter.name = e.target.dataset.filterName;
					}
					else
					{
						calcParameters.recommendedGoods.airFilter.price = 0;
						calcParameters.recommendedGoods.airFilter.name = '';
					}
					sumFullPrice();
					state.calc.setGoodsAirFilter(calcParameters.recommendedGoods.airFilter.name);
				});
			});
		}

		const salonFilterItem = document.querySelectorAll('.modal-calc__table-radio-input[name=salon]');
		if (salonFilterItem.length > 0)
		{
			salonFilterItem[0].setAttribute('checked', 'checked');
			calcParameters.recommendedGoods.salonFilter.price = +salonFilterItem[0].value;
			calcParameters.recommendedGoods.salonFilter.name = salonFilterItem[0].dataset.filterName;
			salonFilterItem.forEach((el) =>
			{
				el.addEventListener('click', (e) =>
				{
					if (e.target.checked)
					{
						calcParameters.recommendedGoods.salonFilter.price = +e.target.value;
						calcParameters.recommendedGoods.salonFilter.name =
							e.target.dataset.filterName;
					}
					else
					{
						calcParameters.recommendedGoods.salonFilter.price = 0;
						calcParameters.recommendedGoods.salonFilter.name = '';
					}
					sumFullPrice();
					state.calc.setGoodsSalonFilter(calcParameters.recommendedGoods.salonFilter.name);
				});
			});
		}
		sumFullPrice();
	}

	function tableFilterElement(filter, type, idx)
	{
		let imagePath = '/images/' + type + 'filter.png';
		if (filter.image)
			imagePath = filter.image;
		return htmlToDom(`
            <table>
                <tbody>
                    <tr class="modal-calc__table-row ${idx > 0 ? `d-none modal-calc__table-filter-${type}-hidden` : ''}">
                        <td class="modal-calc__table-item-recomend">
                            <div class="modal-calc__table-item">
                                <div class="modal-calc__table-item modal-calc__table-item-image-wrapper">
                                    <img src="${imagePath}" class="modal-calc__table-item-image">
                                </div>
                                <div class="modal-calc__table-item modal-calc__table-item-desc">
                                    ${typeof filter.name !== 'undefined' ? filter.name : ""}
                                </div>
                            </div>
                        </td>
                        <td class="modal-calc__table-item-volume"></td>
                        <td class="modal-calc__table-item-cost">
                            <div class="modal-calc__table-item-cost-wrapper">
                                <div class="${filter.count ? 'd-none' : 'modal-calc__table-item'}">Нет в наличии</div>
                               	<div class="${filter.count ? 'modal-calc__table-item' : 'd-none'}">
                                	<span class="modal-calc__table-item-cost-span">Цена:&nbsp</span>
                                	${Math.round(filter.price)}₽
                            	</div>
                            	<div class="${filter.count ? 'modal-calc__table-item' : 'd-none'} modal-calc__table-radio-wrapper">
                                    <label class="modal-calc__table-radio">
                                        <input type="radio" id="${filter.id}" name="${type}" value="${Math.round(filter.price)}" data-oil-name="${filter.name}" class="modal-calc__table-radio-input">
                                        <div class="modal-calc__table-radio-button" data-filter-type="${type}"></div>
                                    </label>
                                </div>
                        	</div>
                        </td>
                    </tr>
                </tbody>
            </table>
        `);
	}

	function tableOilElement(oil, idx, radioName)
	{
		let imagePath = '/images/recommendedOil.png';
		if (oil.image)
			imagePath = oil.image;
		return htmlToDom(`
            <table>
                <tbody>
                    <tr class="modal-calc__table-row ${idx > 0 ? 'd-none modal-calc__table-oil-hidden' : ''}">
                        <td class="modal-calc__table-item-recomend">
                            <div class="modal-calc__table-item">
                                <div class="modal-calc__table-item modal-calc__table-item-image-wrapper">
                                    <img src="${imagePath}" class="modal-calc__table-item-image">
                                </div>
                                <div class="modal-calc__table-item modal-calc__table-item-desc">
                                    ${oil.name}
                                </div>
                            </div>
                        </td>
                        <td class="modal-calc__table-item-volume modal-calc__table-item-volume-body">
                            <div class="modal-calc__table-item">
                                ${oil.price}₽/литр x ${oil.value} ${oil.value >= 5 ? 'литров масла' : 'литра масла'}
                            </div>
                        </td>
                        <td class="modal-calc__table-item-cost">
                            <div class="modal-calc__table-item-cost-wrapper">
                                <div class="${oil.id ? 'd-none' : 'modal-calc__table-item'}">Нет в наличии</div>
                                <div class="${oil.id ? 'modal-calc__table-item' : 'd-none'}">
                                	<span class="modal-calc__table-item-cost-span">Цена:&nbsp</span>${Math.round(+oil.price * oil.value)}₽
                                </div>
                                <div class="${oil.id ? 'modal-calc__table-item' : 'd-none'} modal-calc__table-radio-wrapper">
                                    <label class="modal-calc__table-radio">
                                        <input type="radio" id="${oil.id}" name="${radioName}" value="${Math.round(+oil.price * oil.value)}" data-oil-name="${oil.name}" class="modal-calc__table-radio-input">
                                        <div class="modal-calc__table-radio-button"></div>
                                    </label>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        `);
	}

	function sumFullPrice()
	{
		const recommendedGoods = calcParameters.recommendedGoods;

		let isChangeSalon = false;
		let isChangeAir = false;
		if (!isNaN(recommendedGoods.changeSalon.price) && typeof recommendedGoods.changeSalon.price === 'number' && recommendedGoods.changeSalon.price > 0)
			isChangeSalon = true;
		if (!isNaN(recommendedGoods.changeAir.price) && typeof recommendedGoods.changeAir.price === 'number' && recommendedGoods.changeAir.price > 0)
			isChangeAir = true;

		let totalPrices = 0;
		let types = ['oil', 'oilFilter', 'airFilter', 'salonFilter', 'changeAir', 'changeSalon', 'changeOil'];
		types.forEach((i) =>
		{
			if (!isNaN(recommendedGoods[i].price) && typeof recommendedGoods[i].price === 'number' && recommendedGoods[i].price > 0)
			{
				if (i === 'salonFilter' || i === 'changeSalon')
				{
					if (isChangeSalon)
						totalPrices += recommendedGoods[i].price;
				}
				else if (i === 'airFilter' || i === 'changeAir')
				{
					if (isChangeAir)
						totalPrices += recommendedGoods[i].price;
				}
				else
					totalPrices += recommendedGoods[i].price;
			}
		});

		let mark = document.querySelector('.modal-calc__mark-input').value.trim();
		let model = document.querySelector('.modal-calc__model-input').value.trim();
		let modification = document.querySelector('.modal-calc__modification-input-filled');
		modification = modification.children[0].innerText + ' ' + modification.children[1].innerText + ' ' + modification.children[2].innerText;
		calcParameters.fullComment = 'Автомобиль: ' + mark + ' ' + model + ' ' + modification + '\n';

		document.querySelectorAll('.modal-calc__table-switch-checkbox:checked').forEach((i) =>
		{
			if (i.value != 0)
				calcParameters.fullComment += i.parentNode.parentNode.parentNode.parentNode.parentNode.children[0].textContent.trim() + '\n';
		});
		document.querySelectorAll('.modal-calc__table-radio-input:checked').forEach((i) =>
		{
			calcParameters.fullComment += i.dataset.oilName + '\n';
		})

		calcParameters.fullPrice = totalPrices;
		sumAll.textContent = calcParameters.fullPrice;
	}

	calcPrevBtn.addEventListener('click', (e) =>
	{
		e.preventDefault();
		if (!calcTableBlock.classList.contains('modal-calc__table-wrapper-active'))
			calcSecondToFirst(e);
		else
			calcThirdToSecond(e);
	});

	function calcSecondToFirst(e)
	{
		modalCalcSecond.classList.remove('modal-calc__second-active');
		modalCalcFirst.classList.remove('none');
		calcBtns.classList.remove('modal-calc__bottom-btn-wrapper-active');
		modalCalcModificationBlock.classList.remove('modal-calc__modification-active');
		calcModificationsSelect.classList.remove('modal-calc__modification-select-active');

		calcParameters.mark = null;
		calcParameters.markImg = null;
		calcParameters.model = null;
		calcParameters.modelImg = null;
		calcParameters.modification = null;
		calcParameters.engineCode = null;
		calcParameters.recommendedGoods.oilFilter.name = null;
		calcParameters.recommendedGoods.oil.name = null;
		calcParameters.recommendedGoods.airFilter.name = null;
		calcParameters.recommendedGoods.salonFilter.name = null;
		calcParameters.recommendedGoods.oilFilter.price = 0;
		calcParameters.recommendedGoods.oil.price = 0;
		calcParameters.recommendedGoods.airFilter.price = 0;
		calcParameters.recommendedGoods.salonFilter.price = 0;
		calcParameters.recommendedGoods.changeAir.price = 0;
		calcParameters.recommendedGoods.changeSalon.price = 0;
		calcParameters.recommendedGoods.changeOil.price = 0;
		calcParameters.fullPrice = 0;
		inputMark.value = null;
		inputMarkImg.src = null;
		inputModel.value = null;
		calcModelSelect.innerHTML = ``;
	}

	function calcThirdToSecond(e)
	{
		calcTableBlock.classList.remove('modal-calc__table-wrapper-active');
		calcBtnsMobile.classList.remove('modal-calc__bottom-btn-wrapper-mobile-active');
		calcModelSelect.classList.remove('none');
		calcModificationsSelect.classList.remove('none');
		inputModel.value = null;
		inputModificationFilled.innerHTML = ``;
		modelImgWrapper.innerHTML = ``;
		tableBodyWrapper.innerHTML = ``;

		secondStepTitle.textContent = 'Выберите модель';

		calcModelSelect.classList.remove('modal-calc__model-select-hide');
		modelSearchIcon.classList.remove('modal-calc__model-input-img-hide');
		modelInputBlock.classList.remove('modal-calc__input-block-model-choosen');
		calcModificationsSelect.classList.remove('modal-calc__modification-select-hide');
		modificationSearchIcon.classList.remove('modal-calc__modification-input-img-hide');
		modificationInputBlock.classList.remove('modal-calc__input-block-modification-choosen');

		tableSpinner?.classList.remove('d-none');
		modificationSpinner.classList.add('d-none');
		modificationSpinner.parentElement.classList.add('d-none');

		calcMarkHeader.textContent = 'Выберите марку автомобиля';
		calcModelHeader.textContent = 'Выберите модель';
		calcModificationHeader.textContent = 'Выберите модификацию';
		calcNextBtn.textContent = 'Далее';

		inputModification.classList.add('none');
		inputModificationFilled.classList.add('modal-calc__modification-input-filled-active');
		calcModificationsSelect.classList.remove('modal-calc__modification-select-active');
		modalCalcModificationBlock.classList.remove('modal-calc__modification-active');
		calcNextBtn.classList.add('modal-calc__bottom-btn-next-disabled');
		closeModel.classList.remove('modal-calc__input-close-active');
		closeModification.classList.remove('modal-calc__input-close-active');
		document.querySelector('.modal-calc__model-input').disabled = false;
	}

	async function autosetServices() {
    const siteStates = JSON.parse(localStorage.getItem('siteStates')) || {};
		const changeState = siteStates?.calc?.change || { air: true, salon: true };

		// console.log("Данные из localStorage при загрузке:", changeState);

    await Services.fetch().then((data) => {
        data.forEach((i) => {
            for (let j in presetServeces) {
                const serviceId = Number(i.id);

                if (!presetServeces[j].set) {
                    continue;
                }

                if (i.name.trim().toLowerCase() === presetServeces[j].name.trim().toLowerCase()) {

                    if ((serviceId === 5 && changeState.air === false) || (serviceId === 6 && changeState.salon === false)) {
                        continue;
                    }

                    registrationModal.appendService(i);
                }
            }
        });
    });
}

	async function openRegistration()
	{
		closeBtn.click();
		registrationModal.setComment(calcParameters.fullComment);
		registrationModal.setStepsCheckDisabled(true);
		registrationModal.openStep(2);
		registrationModal.open();
		registrationModal.setStepsCheckDisabled(false);
		await autosetServices();
		registrationModal.fetchAddresses();
		console.log('end');
	}

	async function setCache(mark = null, model = null, modification = null)
	{
		let data = {};
		data.html = encodeURIComponent(document.querySelector('.modal-calc-wrapper').outerHTML);
		if (mark)
			data.mark = mark;
		if (model)
			data.model = model;
		if (modification)
			data.modification = modification;

		let url = '/jsApi/setCache';
		let request =
		{
			method: "POST",
			body: JSON.stringify(data)
		};
		await fetch(url, request);
	}

	async function mutex(condition)
	{
		while (!condition())
			await new Promise(r => setTimeout(r, 200));
	}
};
